import type { FaireProductEntity } from "../../entity_types/product";

export const p_srxcxwxusc: FaireProductEntity = {
  token: "p_srxcxwxusc",
  type: "product",
  name: "Underarm detox kit | natural deodorant kit | detox skin mask",
  brandToken: "b_m3n7j6u3h2",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/0b032dda341b39105302c0722b8919823b0ffc61602b3c0bbd94b8d39bd210ee.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5d25468c0e3062840a5454d0e5ec83f1984d55559a87b309df04bc5fa474d111.jpeg",
    "https://cdn.faire.com/fastly/9f4d694385336c4bd4ef1943e55bc51ce067d39dc7003d587e32d75d1c7de277.jpeg",
    "https://cdn.faire.com/fastly/5ed67ed89a78842115a0542dcf80725576804b7f95d51b243784b939989faf5b.jpeg",
    "https://cdn.faire.com/fastly/0d9d4ad610c650cb2a4f73fa20cd297cbe21293a23898f2feb5b3184521d27f2.jpeg",
    "https://cdn.faire.com/fastly/ebde4cb80d240f7d1fd89f8942169b9397258adda42e64410d1300eb835f40af.jpeg",
    "https://cdn.faire.com/fastly/40fbc1102cb0ce2d12a3286f281879670446be6ae885b43fdbafcb91546ec257.jpeg",
    "https://cdn.faire.com/fastly/cdf3145a5a8fd4c86324db3638713ac73646c2be5df5110ab1ad38eceb00f85f.jpeg",
  ],
  priceDollars: 31.18,
  description:
    "Detox your underarms naturally with our purifying kit. When making the switch to natural deodorant, our bodies need time to detox from heavy metals and other harmful ingredients. Our bamboo activated charcoal mask will help ramp up the detoxification process. \n\nTo use: Mix 1/2 tsp. powder with water to make a paste. Spread the paste on your underarms and let it dry but not harden. Wash away with warm water. Repeat 2-3x per week for 2 weeks. \n\nIncluded:\n-2oz glass jar with purifying charcoal mask\n-40 ML matcha + lemongrass natural deodorant\n-silicone applicator\n-ready to gift!\n\nHandcrafted, hand poured, compostable, vegan, + made with love. Cape Cod, Ma",
  tags: [],
  msrpDollars: 62.36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:30.864Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
